import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HelperService } from '../public/helper.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private helper: HelperService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let requestUrl = request.url;
    // if the request URL have the string prefix,
    // then make the replace by the correct url
    if (this.helper.isMobileApp()) {
      if (requestUrl.indexOf('/api/') !== -1) {
        requestUrl = environment.adminHostURL + requestUrl;
      } else if (requestUrl.indexOf('api/') !== -1) {
        requestUrl = environment.adminHostURL + '/' + requestUrl;
      }
    }

    const headers = this.normalizeHeaderXreferer(request.headers);

    // clone the http request
    request = request.clone({
      url: requestUrl,
      headers: headers,
    });
    // move to next HttpClient request life cycle
    return next.handle(request);
  }

  private normalizeHeaderXreferer(headers: HttpHeaders): HttpHeaders {
    const base = this.helper.isMobileApp()
      ? environment.tenantDomain
      : window.location.origin;

    let finalReferer = base;
    const old = headers.get('X-Referer');

    if (old) {
      try {
        const oldUrl = new URL(old);
        const baseUrl = new URL(base);

        oldUrl.protocol = baseUrl.protocol;
        oldUrl.host = baseUrl.host;

        finalReferer = oldUrl.href;
      } catch {
        finalReferer = base;
      }
    }

    return headers.set('X-Referer', finalReferer);
  }
}
